<template>
  <div v-if="documents.length" class="sd-card divide-y divide-secondary-100">
    <button v-for="d in documents" :key="d._id" class="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-gray-50 focus:outline-none" @click="open(d)">
      <div class="w-9 h-9 rounded bg-secondary-100 flex items-center justify-center text-secondary-600"><BaseIcon icon="file-alt" /></div>
      <div class="flex-1 min-w-0">
        <div class="font-semibold text-gray-800 truncate">{{ d.title }}</div>
        <div class="text-xs text-gray-500">{{ meta }} · <span class="font-mono">v{{ d.currentVersion }}</span></div>
      </div>
      <BaseIcon icon="external-link-alt" class="text-gray-400" />
    </button>
  </div>
</template>

<script>
import api from "../securone.api";

// The document(s) that went out with a broadcast. Opens the current version.
export default {
  name: "DocumentRows",
  props: {
    documents: { type: Array, default: () => [] },
    meta: { type: String, default: "" },
  },
  methods: {
    async open(d) {
      try {
        const file = await api.documentFile(d._id, "current");
        window.open(file.url, "_blank", "noopener");
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>
